import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { RenewQuoteService } from "src/app/main/quoting/renew-quote/renewquote.service";
import { EpAppStore } from "src/app/shared/services/epAppStoreService/epAppStore.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Router } from "@angular/router";

@Component({
  selector: "app-member-enrollment-panel",
  templateUrl: "./member-enrollment-panel.component.html",
  styleUrls: ["./member-enrollment-panel.component.scss"],
  standalone: false,
})
export class MemberEnrollmentPanelComponent implements OnInit, OnDestroy {
  @Input() public group: any;
  @Input() public ancillaryHeading: string;
  @Input() public linkIcon: string;
  @Input() public showMember: boolean;
  @Input() public canEdit: boolean;
  memberForm: FormGroup;
  editMode = false;
  isRenewalOn;
  private unsubscribeAll = new Subject();

  constructor(
    private renewQuoteService: RenewQuoteService,
    private formBuilder: FormBuilder,
    private router: Router,
    private storeService: EpAppStore,
  ) {}

  ngOnInit() {
    const currentQuoteFromStore =
      this.storeService.select("currentQuote").value;
    const { isRenewalQuote, subStatus } = currentQuoteFromStore;
    this.canEdit = subStatus === "Renewed" ? false : true;
    this.isRenewalOn = isRenewalQuote;
    this.memberForm = this.formBuilder.group({
      numberOfEligible: [],
      totalAvgEmployees: [],
      naicsCode: [],
      zipCode: [],
      address1: [""],
      address2: [""],
      city: [""],
    });
  }

  onSubmitMemberInfo() {
    // TODO: Call end point to update field info.
    this.editMode = false;
  }

  generateLink(someValue: string): string {
    // Perfom operations to generate the correct uri to be displayed in the panel.

    return "#";
  }

  getImageIconSrc(): string {
    // Switch statement or operation to return the appropriate uri for the icon to be displayed in the panel.
    switch (this.linkIcon) {
      case "ForRenewAsIs": {
        return "assets/img/u3856.png";
      }
      case "ForRenewQuote": {
        return "assets/img/u5928.png";
      }
      default: {
        return "";
      }
    }

    // return "assets/img/u3856.png";
  }

  onCancel() {
    this.editMode = false;
  }

  onEdit() {
    if (
      !this.memberForm.value.numberOfEligible &&
      this.group.numberOfEligible
    ) {
      this.memberForm.controls.numberOfEligible.setValue(
        this.group.numberOfEligible,
      );
    }
    if (
      !this.memberForm.value.totalAvgEmployees &&
      this.group.totalAverageEmployees
    ) {
      this.memberForm.controls.totalAvgEmployees.setValue(
        this.group.totalAverageEmployees,
      );
    }
    this.editMode = true;
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  viewMembership(id) {
    this.router.navigate(["/main/group-details/membership-details/" + id]);
  }

  updateMemberEnrollment() {
    const quoteID =
      this.group?.quoteId ||
      this.storeService.select("currentQuote").value.quoteId;
    const numberOfEligible = this.memberForm.value.numberOfEligible
      ? this.memberForm.value.numberOfEligible
      : 0;
    const totalAvgEmployees = this.memberForm.value.totalAvgEmployees
      ? this.memberForm.value.totalAvgEmployees
      : 0;
    const quoteType = this.isRenewalOn ? "RENEWAL" : "PROSPECT";
    const body = {
      quoteId: quoteID,
      numberOfEmployees: numberOfEligible,
      prevAvgNumberOfEmployees: totalAvgEmployees,
    };

    this.renewQuoteService
      .updateMemberEnrollment(body, quoteType)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((response) => {
        if (response) {
          this.group.numberOfEligible = numberOfEligible;
          this.group.totalAverageEmployees = totalAvgEmployees;
          this.onCancel();
        }
      });
  }
}
